export const REVIEWS_PAGE_LIMIT = 10;
export const PRODUCT_GRID_PAGE_LIMIT = 30;

export const CONTENT_TYPE_HEADER = 'Content-Type';
export const X_PROJECT_HEADER = 'X-Project';
export const X_FB_EVENT_ID = 'X-FB-Event-ID';
